import { Text } from "@radix-ui/themes";

export default function AbstractNotice() {
    return (
        <Text size="1" color="crimson">* 原始文章地址可能暂时无法访问，本页为文章的摘要信息</Text>
    )
}